export const viewTitle = "Список дел";
export const viewUniqKey = "inventory";
